import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

import { BlankButton } from '../BlankButton';

type BodyTypes = {
  isOpen?: boolean;
};

export const Container = styled.div<LayoutProps & SpaceProps>`
  display: flex;
  justify-content: space-between;
  white-space: pre-wrap;
  border-top: 1px solid ${tokens.colors.grayLight};
  min-height: 57px;

  ${layout};
  ${space};

  &:last-child {
    border-bottom: 1px solid ${tokens.colors.grayLight};
  }
`;

export const Content = styled.div`
  padding: ${tokens.space.regular} ${tokens.space.regular} ${tokens.space.large} 0;
  width: 100%;
`;

export const Title = styled.div`
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.l};
  line-height: ${tokens.lineHeights.l};
  color: ${tokens.colors.black};
  cursor: pointer;
`;

export const Body = styled.div<BodyTypes>`
  font-size: 15px;
  line-height: ${tokens.lineHeights.m};
  padding-top: ${tokens.space.regular};
  color: #545658;
  display: ${({ isOpen }): string => (isOpen ? 'block' : 'none')};
`;

export const CollapseDownButton = styled(BlankButton)`
  height: fit-content;
  margin-top: ${tokens.space.regular};
  padding-right: 0;
  color: ${tokens.colors.primary};
`;
